//@flow
import Stopwatch from 'app/packages/trace-logger/Stopwatch';
import traceLogger from 'app/packages/trace-logger/singleton';

export default function addPageSubStopwatches(currTimer: ?Stopwatch, metricName: string) {
  if (currTimer) {
    currTimer.addSubStopwatch(
      new Stopwatch({
        name: 'ttfb',
        metricName,
        parent: currTimer,
        startTime: window.performance.timing.requestStart,
        endTime: window.performance.timing.responseStart,
      }),
    );
    currTimer.addSubStopwatch(
      new Stopwatch({
        name: 'fid',
        metricName,
        parent: currTimer,
        startTime: window.performance.timing.firstInputDelayStart,
        endTime: window.performance.timing.firstInputDelayEnd,
      }),
    );
    const location = traceLogger.serverTraceData.path || window.location.href;
    currTimer.addSubStopwatch(
      new Stopwatch({
        name: location === '/' ? '/homefeed' : location,
        metricName,
        spanId: traceLogger.serverTraceData.server_span_id || undefined,
        parent: currTimer,
        startTime: window.performance.timing.requestStart,
        endTime: window.performance.timing.responseEnd,
      }),
    );
  }
}
